import { useEffect, useRef } from "react";
import "./Footer.css";
import {
  Facebook,
  Instagram,
  Linkedin,
  Youtube,
  Mail,
  Phone,
  MapPin,
  MessageCircle,
  Link2,
} from "lucide-react";
import logo from "../../assets/logo.png";

const EMAIL = "nesflixdigital@gmail.com";
const PHONE_DISPLAY = "+94 70 513 5373";
const PHONE_E164 = "94705135373"; // no + sign (for wa.me)
const TIKTOK_URL = "https://tiktok.com/@nesflix_digital";

const CREDIT_NAME = "Auricode Solutions";
const CREDIT_LINK = "https://auricodesolutions.com/";

/* --- SVG Icons (TikTok, X, Dribbble, Behance) --- */
const TikTokIcon = ({ size = 18 }) => (
  <svg
    width={size}
    height={size}
    viewBox="0 0 48 48"
    fill="currentColor"
    xmlns="http://www.w3.org/2000/svg"
    aria-hidden="true"
  >
    <path d="M34.8 6c.5 4.4 3.6 7.9 8 8.4v7.6c-3.1.1-6.1-.9-8.7-2.6v13.8c0 7.2-5.9 13-13.1 12.8-7-.2-12.7-6-12.7-13 0-7.3 6-13.1 13.3-12.8v7.8c-2.9-.4-5.6 1.8-5.9 4.7-.3 2.8 1.7 5.4 4.5 5.9 3.2.5 6.1-1.9 6.1-5V6h8.5z" />
  </svg>
);

const XIcon = ({ size = 18 }) => (
  <svg width={size} height={size} viewBox="0 0 24 24" fill="currentColor" xmlns="http://www.w3.org/2000/svg" aria-hidden="true">
    <path d="M18.9 2H22l-6.8 7.8L23 22h-6.7l-5.2-6.9L5 22H2l7.3-8.4L1 2h6.8l4.7 6.2L18.9 2Zm-1.2 18h1.7L6.9 3.9H5.1L17.7 20Z"/>
  </svg>
);

const DribbbleIcon = ({ size = 18 }) => (
  <svg width={size} height={size} viewBox="0 0 24 24" fill="currentColor" xmlns="http://www.w3.org/2000/svg" aria-hidden="true">
    <path d="M12 2a10 10 0 1 0 0 20 10 10 0 0 0 0-20Zm7.9 9.2c-1.7-.3-3.4-.3-5.1 0-.2-.5-.4-1-.6-1.5 1.6-.7 3.2-1.7 4.5-3 0 0 1.1 1.8 1.2 4.5ZM17.4 5.1c-1.2 1.2-2.6 2.1-4.1 2.7A46 46 0 0 0 10.6 3c.5-.1 1-.2 1.4-.2 2.1 0 4 .8 5.4 2.3ZM8.9 3.6c1 1.5 1.9 3.1 2.6 4.8-2 .6-4.2.8-6.3.7A8 8 0 0 1 8.9 3.6ZM4.1 11.6c2.3.1 4.7-.2 6.9-.9.2.5.4.9.6 1.4-2.5.8-4.8 2.2-6.6 4.1a7.9 7.9 0 0 1-.9-4.6Zm2.2 6.4c1.6-1.7 3.7-2.9 6-3.7.6 1.7 1.1 3.5 1.4 5.3A8 8 0 0 1 6.3 18Zm9.3 1.3c-.3-1.7-.8-3.4-1.4-5.1 1.5-.3 3-.3 4.6 0a8 8 0 0 1-3.2 5.1Z"/>
  </svg>
);

const BehanceIcon = ({ size = 18 }) => (
  <svg width={size} height={size} viewBox="0 0 24 24" fill="currentColor" xmlns="http://www.w3.org/2000/svg" aria-hidden="true">
    <path d="M8.2 12.1c1.1-.5 1.9-1.4 1.9-2.8 0-2.1-1.5-3.3-4.2-3.3H1.8v12h4.4c3 0 4.7-1.2 4.7-3.7 0-1.8-1-2.8-2.7-3.2ZM4 8h2.1c1.2 0 1.9.4 1.9 1.4 0 1.1-.7 1.5-2 1.5H4V8Zm2.3 7.9H4V12.6h2.5c1.3 0 2.1.5 2.1 1.6 0 1.3-.8 1.7-2.3 1.7ZM22.2 13.8c0-2.8-1.6-4.7-4.4-4.7-2.9 0-4.7 2-4.7 4.9 0 2.9 1.8 4.8 4.8 4.8 2.1 0 3.6-1 4.1-2.7h-2.3c-.2.6-.8 1-1.8 1-1.2 0-2-.7-2.1-2h6.4v-.3Zm-6.4-1.1c.1-1.1.8-1.8 2-1.8 1.1 0 1.8.6 1.9 1.8h-3.9ZM15.4 6.7h4.7V8h-4.7V6.7Z"/>
  </svg>
);

/* ✅ Social links (fill what you have now) */
const socials = [
  { name: "Facebook", href: "https://www.facebook.com/profile.php?id=61586310862626", Icon: Facebook },   // add your FB page link
  { name: "LinkedIn", href: "#", Icon: Linkedin },   // add if available
  { name: "Instagram", href: "https://www.instagram.com/nesflixdigital/?hl=en", Icon: Instagram }, // add if available
  { name: "YouTube", href: "#", Icon: Youtube },     // add if available
  { name: "TikTok", href: "https://www.tiktok.com/@nesflix_digital", Icon: TikTokIcon }, // ✅ from FB page
  { name: "X", href: "#", Icon: XIcon },
  { name: "Dribbble", href: "#", Icon: DribbbleIcon },
  { name: "Behance", href: "#", Icon: BehanceIcon },
];

export default function Footer() {
  const year = new Date().getFullYear();
  const footerRef = useRef(null);

  const ripple = (e) => {
    const btn = e.currentTarget;
    const r = btn.getBoundingClientRect();
    const x = ((e.clientX - r.left) / r.width) * 100;
    const y = ((e.clientY - r.top) / r.height) * 100;
    btn.style.setProperty("--px", `${x}%`);
    btn.style.setProperty("--py", `${y}%`);
    btn.classList.remove("is-rippling");
    // eslint-disable-next-line no-unused-expressions
    btn.offsetWidth;
    btn.classList.add("is-rippling");
  };

  useEffect(() => {
    const el = footerRef.current;
    if (!el) return;

    const raf = requestAnimationFrame(() => el.classList.add("is-mounted"));

    const io = new IntersectionObserver(
      ([entry]) => {
        if (entry.isIntersecting) {
          el.classList.add("is-visible");
          io.disconnect();
        }
      },
      { threshold: 0.18 }
    );

    io.observe(el);
    return () => {
      cancelAnimationFrame(raf);
      io.disconnect();
    };
  }, []);

  return (
    <footer className="footer2" id="footer" ref={footerRef}>
      {/* decor */}
      <div className="footer2__bg" aria-hidden="true">
        <span className="footer2__orb footer2__orb--1" />
        <span className="footer2__orb footer2__orb--2" />
      </div>

      {/* TOP CTA */}
      <div className="container footer2__cta">
        <p className="footer2__eyebrow reveal" style={{ "--d": "0ms" }}>
          LET’S WORK TOGETHER
        </p>

        <a className="footer2__email reveal" style={{ "--d": "90ms" }} href={`mailto:${EMAIL}`}>
          {EMAIL}
        </a>

        <div className="footer2__line reveal" style={{ "--d": "180ms" }} />
      </div>

      {/* MIDDLE DETAILS */}
      <div className="container footer2__mid">
        <div className="footer2__col reveal" style={{ "--d": "0ms" }}>
          <div className="footer2__brand">
            <div className="footer2__logoBadge">
              <img className="footer2__logoImg" src={logo} alt="NesflixDigital" />
            </div>
            <div>
              <div className="footer2__brandText">NesflixDigital</div>
              <div className="footer2__tag">
                Social media marketing, content, and branding for modern businesses.
              </div>
            </div>
          </div>

          {/* ✅ Updated to match FB page contact info */}
          <div className="footer2__mini">
            <div className="footer2__miniRow">
              <Mail size={16} />
              <a href={`mailto:${EMAIL}`}>{EMAIL}</a>
            </div>

            <div className="footer2__miniRow">
              <Phone size={16} />
              <a href={`tel:+${PHONE_E164}`}>{PHONE_DISPLAY}</a>
            </div>

            <div className="footer2__miniRow">
              <MessageCircle size={16} />
              <a href={`https://wa.me/${PHONE_E164}`} target="_blank" rel="noreferrer">
                WhatsApp: {PHONE_DISPLAY}
              </a>
            </div>

            <div className="footer2__miniRow">
              <Link2 size={16} />
              <a href={TIKTOK_URL} target="_blank" rel="noreferrer">
                tiktok.com/@nesflix_digital
              </a>
            </div>

            <div className="footer2__miniRow">
              <MapPin size={16} />
              <span>Sri Lanka</span>
            </div>
          </div>
        </div>

        <div className="footer2__col footer2__linksCol reveal" style={{ "--d": "90ms" }}>
          <div className="footer2__h">Quick Links</div>

          <div className="footer2__linkGrid">
            <a className="footer2__link" href="#home">Home</a>
            <a className="footer2__link" href="#about">About</a>
            <a className="footer2__link" href="#services">Services</a>
            <a className="footer2__link" href="#work">Work</a>
            <a className="footer2__link" href="#contact">Contact</a>
          </div>
        </div>

        <div className="footer2__col reveal" style={{ "--d": "180ms" }}>
          <div className="footer2__h">Services</div>
          <div className="footer2__pill">Meta & TikTok Ads</div>
          <div className="footer2__pill">Google Ads & SEO</div>
          <div className="footer2__pill">Content & Design</div>
          <div className="footer2__pill">Landing Pages</div>
          <div className="footer2__pill">Analytics & Reporting</div>
        </div>

        <div className="footer2__col reveal" style={{ "--d": "270ms" }}>
          <div className="footer2__h">Newsletter</div>
          <div className="footer2__small">
            Monthly tips, creative ideas, and ad updates. No spam.
          </div>

          <form className="footer2__newsletter" onSubmit={(e) => e.preventDefault()}>
            <input className="footer2__input" placeholder="Your email address" />
            <button className="footer2__send" onPointerDown={ripple} type="submit">
              Subscribe
            </button>
          </form>

          <div className="footer2__small2">By subscribing you agree to our updates.</div>
        </div>
      </div>

      {/* BOTTOM ROW */}
      <div className="container footer2__bottom">
        <div className="footer2__socials">
          {socials.map(({ name, href, Icon }, idx) => (
            <a
              key={name}
              className="footer2__social reveal"
              style={{ "--d": `${idx * 55}ms` }}
              href={href}
              target="_blank"
              rel="noreferrer"
              aria-label={name}
              title={name}
              onPointerDown={ripple}
            >
              <Icon size={18} />
            </a>
          ))}
        </div>

        <div className="footer2__legal">
          <div>© {year} NesflixDigital. All rights reserved.</div>
          <div className="footer2__credit">
            Crafted by{" "}
            <a href={CREDIT_LINK} target="_blank" rel="noreferrer">
              {CREDIT_NAME}
            </a>
          </div>
        </div>
      </div>
    </footer>
  );
}
